<template>
  <div class="expandableText">
    <div ref="textRef" :class="['text-content', { 'collapsed': isCollapsed && needExpand }]">{{ text }}</div>
    <!-- 展开/收起按钮 -->
    <button v-if="needExpand && isCollapsed" class="expand-btn" @click="toggleExpand"><span class="expand-btn-overflow">...</span>展开<i class="el-icon-arrow-down"></i></button>
  </div>
</template>

<script>
  export default {
    name: 'ExpandableText',
    props: {
      text: {
        type: String,
        default: ''
      },
      // 最大行数
      maxLines: {
        type: Number,
        default: 4
      }
    },
    data() {
      return {
        isCollapsed: true,
        needExpand: false
      }
    },
    mounted() {
      this.checkNeedExpand()
    },
    methods: {
      checkNeedExpand() {
        this.$nextTick(() => {
          const el = this.$refs.textRef
          if (!el) return
          
          // 临时移除折叠样式，获取完整高度
          const originalClass = el.className
          el.classList.remove('collapsed')
          
          const fullHeight = el.scrollHeight
          const lineHeight = parseFloat(getComputedStyle(el).lineHeight)
          const maxHeight = lineHeight * this.maxLines
          
          // 判断是否超过最大行数
          this.needExpand = fullHeight > maxHeight
          
          // 恢复原来的样式
          if (this.isCollapsed) {
            el.classList.add('collapsed')
          }
        })
      },
      handleResize() {
        this.checkNeedExpand()
      },
    
      toggleExpand() {
        this.isCollapsed = !this.isCollapsed
      }
    },
    watch: {
      text() {
      // 文本变化时重新判断
        this.isCollapsed = true
        this.$nextTick(() => {
          this.checkNeedExpand()
        })
      }
    }
  }
</script>

<style lang="less" scoped>
.expandableText {
  position: relative;
  z-index: 1;
  width: 100%;
}

.text-content {
  word-break: break-word;
  line-height: 1.5; /* 设置固定行高 */
}

/* 折叠样式：最多显示4行 */
.text-content.collapsed {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: v-bind(maxLines);
  -webkit-box-orient: vertical;
}

.expand-btn {
  position: absolute;
  z-index: 2;
  bottom: 0;
  right: 0;
  color: #409eff;
  background: #FFFFFF;
  border: none;
  cursor: pointer;
  font-size: 14px;
  padding: 0;
}

.expand-btn:hover {
  color: #66b1ff;
}

.expand-btn-overflow {
  color: #000000;
}
</style>